import axios from 'axios';
import config from '@/config';
import { getAccessToken, setTokens, clearAuth } from '@/utils/auth';
import useAuthStore from '@/store/authStore';

/**
 * Axios instance with default configuration
 */
const apiClient = axios.create({
  baseURL: config.api.baseURL,
  timeout: config.api.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
});


/**
 * Request Interceptor
 * Adds authorization token to requests
 */
apiClient.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Response Interceptor
 * Handles error responses
 */
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    // If error is 401, clear tokens and redirect gracefully
    if (error.response?.status === 401) {
      clearAuth();
      useAuthStore.getState().clearAuth();
      // Use client-side routing or let ProtectedRoute handle the redirect
      if (window.location.pathname !== '/login') {
        // window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
